import * as Sentry from '@sentry/browser'
import { BrowserOptions } from '@sentry/browser/types/client'

export function configureSentry(options: BrowserOptions) {
  Sentry.init({
    dsn: options.dsn,
    debug: options.debug,
    release: options.release,
    environment: options.environment,
    tracesSampleRate: options.tracesSampleRate,
    integrations: [new Sentry.BrowserTracing()],
    // silence this error. it's related to some password manager like lastpass as it only happens on our login page.
    ignoreErrors: ['Non-Error promise rejection captured'],
  })
}
